import { FileText, Clock, CheckCircle, PoundSterling } from "lucide-react";

function StatsCards({ stats, formatCurrency }) {
  if (!stats) return null;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      <div className="bg-white rounded-lg shadow-lg p-6" data-testid="stat-total-quotes">
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 bg-slate-100 rounded-lg flex items-center justify-center">
            <FileText className="text-slate-600" size={24} />
          </div>
          <div>
            <p className="text-stone-500 text-sm">Total Quotes</p>
            <p className="text-3xl font-bold text-slate-900">{stats.total_quotes}</p>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-lg p-6" data-testid="stat-pending">
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 bg-amber-100 rounded-lg flex items-center justify-center">
            <Clock className="text-amber-600" size={24} />
          </div>
          <div>
            <p className="text-stone-500 text-sm">Pending</p>
            <p className="text-3xl font-bold text-slate-900">{stats.pending}</p>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-lg p-6" data-testid="stat-completed">
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
            <CheckCircle className="text-green-600" size={24} />
          </div>
          <div>
            <p className="text-stone-500 text-sm">Completed</p>
            <p className="text-3xl font-bold text-slate-900">{stats.completed}</p>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-lg p-6" data-testid="stat-total-value">
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
            <PoundSterling className="text-blue-600" size={24} />
          </div>
          <div>
            <p className="text-stone-500 text-sm">Total Value</p>
            <p className="text-2xl font-bold text-slate-900">{formatCurrency(stats.total_value)}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StatsCards;
